module.exports = __webpack_public_path__ + "static/img-delray-downtown-552b454760028e21f1a87660960b6bb9.jpg";